import { TCronDefinition }           from "store/cronDefinitions/d";
import { CRON_DEFINITIONS_SET_DATA } from "store/cronDefinitions/types";

export const _actionCronDefinitionSetData = (payload: TCronDefinition[]) => ({
    type: CRON_DEFINITIONS_SET_DATA,
    payload
})
